import React from "react";
import NavBar from "../Navbar/Navbar";
import "./HeroSection.css";
import { useNavigate } from "react-router-dom";

//pb-5 hero-section-bg-img-phone

export default function MobileHero() {
  const navigate = useNavigate();
  return (
    <div className=" relative flex w-screen bg-[#F6F1EB] flex-col gap-3 px-4 z-0 min-h-fit pb-3  sm:hidden">
      <img
        src="/assets/img/bgGrid.png"
        className="absolute top-0 left-0 h-full w-full object-cover -z-10 "
      />

      <NavBar />
      {/* Headings */}
      <h2 className="text-[30px] xs:text-[24px] w-full text-center leading-[1.2] font-bomstad-semibold text-black">
        Personal Loans
        <br />
        with Instant Approval & <br />
        <span className="italic font-pp-hatton text-[32px] xs:text-[28px] bg-green-400 px-1 rounded">
          Quick Bank Transfer
        </span>
      </h2>

      <div className="relative min  h-[160px] font-atkinson text-[14px]  mt-4 mb-4">
        {/* Horizontal lines */}
        <div className="absolute top-0 left-[-40px] w-[100%] border-t-[2px] border-black" />

        <div className="absolute bottom-[50%] left-10 w-4/6 border-t-[2px] border-black" />

        <div className="absolute bottom-0 right-5 w-3/4 border-t-[2px] border-black" />

        {/* Vertical lines */}
        <div className="absolute top-0 left-1/2 h-[50%] border-l-[2px] border-black" />
        <div className="absolute top-[50%] left-1/3 h-[50%] border-l-[2px] border-black" />

        {/* Text boxes */}
        <div className="relative w-full max-w-[500px] min-h-[160px] max-h-[180px]">
          <div className="absolute top-[6%] left-[15%] xs:left-[10%] w-[50%] pr-2 font-atkinson text-[clamp(17px,2.5vw,18px)] xs:text-[16px] leading-[1.1]">
            Get up-to <strong>1 Cr</strong>
            <br />
            in Unsecured <br /> Business Loan
          </div>

          <div className="absolute top-[6%] right-[-2%] w-[50%] pl-2 font-atkinson text-[clamp(17px,2.5vw,18px)] xs:text-[16px] leading-[1.1]">
            Customized
            <br />
            Loans for Indian <br /> <strong>MSMEs</strong>
          </div>

          <div className="absolute bottom-[7%] right-[15%] w-[50%] pl-2 text-left font-atkinson text-[clamp(17px,2.5vw,18px)] xs:text-[16px] leading-[1.1]">
            Get offers from <strong></strong>
            <br />
            Banks/NBFCs
          </div>
        </div>
      </div>

      {/* Image */}
      <div className="w-full flex justify-center">
        <img
          src="/assets/img/Mobile Personal loan Image.png"
          alt="Hero"
          className="rounded-3xl w-full "
        />
      </div>

      {/* CTA */}
      <div className="relative flex flex-col   py-5 px-4 mt-2 rounded-2xl font-atkinson  z-0">
        <img
          src="/assets/img/Mobile business loan Patch.png"
          className="absolute top-0 left-0 w-full h-full -z-10"
        />
        <p className="text-[20px] xs:text-[18px] mb-3">
          Fuel Your Dreams with a <br /> Hassle-Free Journey Designed Around
          Your Life
        </p>
        <button
          onClick={() => {
            navigate("/personal-loan-v17?aff_id=1&utm_medium=SMS");
          }}
          className="flex items-center justify-center gap-3 border-[1.5px] border-black text-black px-4 xs:px-3 max-w-[70%] py-3 xs:py-2 rounded-full text-sm"
        >
          Apply Now
          <img src="/assets/img/cta_arrow_new.png" className="w-5" />
        </button>
      </div>
    </div>
  );
}
